import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux'
import { Container, Grid, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import NotListedLocationOutlinedIcon from '@material-ui/icons/NotListedLocationOutlined';
import CategoryList from './Category/CategoryList'
import MobileCategoryList from './Category/MobileCategoryList'
import FilterBar from './Menu/FilterBar'
import Banner from './Banner/Banner'
const Panel = lazy(() => import('./Menu/Panel'))


const useStyles = makeStyles((theme) => ({
  notAvailable: {
    height: '45vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionHeader: {
    marginBottom: theme.spacing(2),
    paddingBottom: '10px',
    textTransform: 'uppercase',
    textAlign: 'left',
    borderBottom: '1px solid #bdbdc1',
    display: 'flex',
    alignItems: 'center',
  }
}));


const App = (props) => {

  const theme = useTheme();
  const classes = useStyles()
  const xs = useMediaQuery(theme.breakpoints.down('xs'));
  // const xsSm = useMediaQuery(theme.breakpoints.between('xs', 'sm'));

  const ui = []

  ui[0] = <Banner key={0} />


  if (xs) {
    ui[0] = null
    ui[1] = (
      <div key={1}>
        <MobileCategoryList />
        <Container>
          <FilterBar />
          <Suspense fallback={<div>Loading...</div>}>
            <Panel />
          </Suspense>
        </Container>
      </div>
    )
  } else {
    ui[1] = (
      <Container key={1}>
        <Grid container spacing={2} className={classes.sectionHeader}>
          <Grid item sm={3} xs={12}>
            <Typography component="h2" variant="h5" color="primary" className={classes.sectionHeader1}>CATEGORIES</Typography>
          </Grid>
          <Grid item sm={9} xs={12}>
            <FilterBar />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item sm={3} xs={12}>
            <CategoryList />
          </Grid>
          <Grid item sm={9} xs={12}>
            <Suspense fallback={<div>Loading...</div>}>
              <Panel />
            </Suspense>
          </Grid>
        </Grid>
      </Container>
    );
  }

  const nearestOutlet = props.meta.nearestOutlet
  if (nearestOutlet.searchCompleted && !nearestOutlet.id) {
    ui[1] = (
      <Container key={1}>
        <div className={classes.notAvailable}>
          <Typography component="h2" variant="h4" align="center" color="primary">
            <NotListedLocationOutlinedIcon /> Sorry, This location is not serviceable
           </Typography>
        </div>
      </Container>
    )
  }

  return (<div>
    {ui}
  </div>)

}

const mapStateToProps = (state) => {
  return { meta: state.meta }
}

export default connect(mapStateToProps, {})(App)
